module.exports = __webpack_public_path__ + "img/tipocontacto011.354169b.svg";